// Navigation à deux étages : les familles au-dessus, les onglets de la famille
// active en dessous.
//
// Avant, onze onglets tenaient sur une seule barre en `flex-wrap` et
// débordaient sur deux lignes. Le défaut n'était pas la place : c'était qu'aucun
// ordre ne se lisait. « Collecteurs » voisinait « Combien je paie » sans que
// rien ne dise que l'un parle de tuyaux et l'autre d'argent.
//
// Ici, la première barre ne dépasse jamais trois boutons et la seconde cinq.
// Aucune ne peut plus déborder, et surtout chaque écran annonce à quelle
// question il répond.

import {
  GROUPES, groupeDeLOnglet, ongletDEntree, ongletDefaut, ongletsDuGroupe,
} from "../lib/onglets.js";

/**
 * Monte les deux barres. À appeler une fois, APRÈS que `window.setTab` existe :
 * les boutons l'appellent au clic, et un clic rapide au chargement tomberait
 * sinon dans le vide.
 */
export function monterNavigation() {
  const barreGroupes = document.querySelector(".groupes");
  const barreOnglets = document.querySelector(".tabs");
  if (!barreGroupes || !barreOnglets) return;

  const frag = document.createDocumentFragment();
  for (const g of GROUPES) {
    const b = document.createElement("button");
    b.type = "button";
    b.className = "groupe";
    b.dataset.groupe = g.id;
    b.textContent = g.libelle;
    // Un clic sur la famille mène à son premier onglet — jamais à un état où la
    // famille est allumée sans qu'aucun écran ne soit choisi.
    b.addEventListener("click", () => window.setTab(ongletDEntree(g.id).id));
    frag.appendChild(b);
  }
  barreGroupes.replaceChildren(frag);

  synchroniserNavigation(ongletDefaut().id);
}

/**
 * Aligne les deux barres sur l'onglet réellement actif.
 *
 * Appelée par `setTab`, donc y compris quand la bascule vient d'ailleurs que de
 * la barre : les tuiles de l'écran d'accueil sautent directement sur
 * « Alertes » ou « Fournisseurs ». C'est précisément ce cas qui impose de
 * reconstruire la seconde barre ici plutôt que dans le gestionnaire de clic —
 * sans ça, l'onglet cible n'aurait parfois même pas de bouton à allumer.
 */
export function synchroniserNavigation(idOnglet) {
  const barreOnglets = document.querySelector(".tabs");
  if (!barreOnglets) return;
  const idGroupe = groupeDeLOnglet(idOnglet);

  for (const b of document.querySelectorAll(".groupe[data-groupe]")) {
    const actif = b.dataset.groupe === idGroupe;
    b.classList.toggle("active", actif);
    b.setAttribute("aria-current", actif ? "true" : "false");
  }

  // La seconde barre est reconstruite plutôt que masquée : garder onze boutons
  // dans le DOM en n'en montrant que cinq laisserait les autres atteignables au
  // clavier, dans un ordre que rien n'explique.
  const frag = document.createDocumentFragment();
  for (const o of ongletsDuGroupe(idGroupe)) {
    const b = document.createElement("button");
    b.type = "button";
    b.className = "tab" + (o.id === idOnglet ? " active" : "");
    b.dataset.onglet = o.id;
    b.textContent = o.libelle;
    b.addEventListener("click", () => window.setTab(o.id));
    frag.appendChild(b);
  }
  barreOnglets.replaceChildren(frag);
}
